import React from "react";
import { Link } from "react-router-dom";
import { notFound } from "../../assets";

const Undifiend = () => {
  return (
    <div className="undifiend">
      <img src={notFound} alt="" />
      
        <Link to="/" >Back to Home</Link>
      
    </div>
  );
};

export default Undifiend;
